// Code review - In Progress
// Documentation - In Progress

import TextEditor from "../ReusableComponents/TextEditor";

const DownloadQuestionsPopup = (data) => {

    return (
        <div className="h-80 flex items-center justify-center p-10">

            <TextEditor
                value={data.data}
                name="topicInformation"
                height={200}
                disabled={true}
            />


        </div>
    );
};

export default DownloadQuestionsPopup;

